export class PrintLabelController {
  private objCheckboxSelected;

  constructor(private Pedido) {}

  async openPdf(pdf) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(pdf.response);
    } else {
      const objectUrl = URL.createObjectURL(pdf.response);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.target = "_blank";
      link.click();
    }

    return true;
  }

  async sendToPrint(labelsCode, unique) {
    const pdf = await this.Pedido.printLabel(labelsCode);
    const obj = {
      Source:
        window.location.pathname.indexOf("historico") === -1
          ? "Package list"
          : "Order history",
      Button_type: unique ? "Inline" : "Batch",
      Labels_selected: labelsCode.length,
    };
    await this.openPdf(pdf);
  }

  calculateLengthObj(items) {
    let lengthObj = 0;

    for (const unit in items) {
      if (items.hasOwnProperty(unit)) {
        ++lengthObj;
      }
    }

    return lengthObj;
  }

  allSelected(objStatus, itemsOnScreen) {
    if (
      this.hasNoSelected(objStatus) !== false &&
      this.calculateLengthObj(objStatus.items) === itemsOnScreen
    ) {
      return (objStatus.checked = true);
    } else {
      return (objStatus.checked = false);
    }
  }
  // objStatus = metodo recebe o obj com os estados do input selector all e a lista de inputs para serem selecionados
  // listSelectable = lista de items para selecionar
  // reset = se true, reseta o estado do objStatus
  toggleSelectAll(objStatus, listSelectable, reset) {
    const objReset = { checked: false, items: {} };
    if (reset) {
      return objReset;
    } else {
      this.objCheckboxSelected = Object.assign({}, objStatus);

      if (listSelectable) {
        listSelectable.map((item) => {
          if (
            item.id &&
            (item.codigoSituacao === "Nova" ||
              item.codigoSituacao === "NaoColetada")
          ) {
            this.objCheckboxSelected.items[item.id] = objStatus.checked;
          }
        });
      }

      return this.calculateLengthObj(this.objCheckboxSelected.items) > 0
        ? this.objCheckboxSelected
        : objReset;
    }
  }

  hasNoSelected(objStatus) {
    for (const item in objStatus.items) {
      if (!objStatus.items[item]) {
        return false;
      }
    }
  }

  hasSelected(objStatus, itemsOnScreen) {
    for (const item in objStatus.items) {
      if (objStatus.items[item]) {
        this.allSelected(objStatus, itemsOnScreen);
        return true;
      } else {
        this.allSelected(objStatus, itemsOnScreen);
      }
    }
  }

  async getLabelsToPrint(orders, allSortedItems: any[]) {
    if (typeof orders === "object") {
      let codes = [];
      for (const chk in orders.items) {
        if (orders.items[chk]) {
          codes.push(chk);
        }
      }

      if (allSortedItems) {
        codes = allSortedItems.filter((i) => codes.indexOf(i) > -1);
      }

      await this.sendToPrint(codes, false);
    } else {
      await this.sendToPrint([orders], true);
    }
  }
}
